var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.75,
    width: 29,
    height: 26.5,
    rx: 4,
    fill: "#6E7D83",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M8.5 9.625C8.5 9.16016 8.90625 8.75 9.42857 8.75H20.5714C21.0647 8.75 21.5 9.16016 21.5 9.625C21.5 10.1172 21.0647 10.5 20.5714 10.5H9.42857C8.90625 10.5 8.5 10.1172 8.5 9.625ZM8.5 14C8.5 13.5352 8.90625 13.125 9.42857 13.125H20.5714C21.0647 13.125 21.5 13.5352 21.5 14C21.5 14.4922 21.0647 14.875 20.5714 14.875H9.42857C8.90625 14.875 8.5 14.4922 8.5 14ZM21.5 18.375C21.5 18.8672 21.0647 19.25 20.5714 19.25H9.42857C8.90625 19.25 8.5 18.8672 8.5 18.375C8.5 17.9102 8.90625 17.5 9.42857 17.5H20.5714C21.0647 17.5 21.5 17.9102 21.5 18.375Z",
    fill: "#009BDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReorder);
export default __webpack_public_path__ + "static/media/icon_reorder.465f7fc666afe44b26c1038489011a8b.svg";
export { ForwardRef as ReactComponent };